import { render } from "./EditRoleComponent.vue?vue&type=template&id=34a48190"
import script from "./EditRoleComponent.vue?vue&type=script&lang=js"
export * from "./EditRoleComponent.vue?vue&type=script&lang=js"
script.render = render

export default script